import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=b4aaf0f4&"
import script from "./ContextMenu.vue?vue&type=script&lang=js&"
export * from "./ContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4aaf0f4')) {
      api.createRecord('b4aaf0f4', component.options)
    } else {
      api.reload('b4aaf0f4', component.options)
    }
    module.hot.accept("./ContextMenu.vue?vue&type=template&id=b4aaf0f4&", function () {
      api.rerender('b4aaf0f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/ContextMenu.vue"
export default component.exports